import { Box } from "@mui/material";
import { useState } from "react";

// COMPONENTS
import Navbar from "../components/Navbar";
import ChargesList from "../components/ChargesList";
import Footer from "../components/Footer";
import FeedbackAlert from "../components/FeedbackAlert";

// CHARGES
export default function Charges({ setChargesCalculator, charges, isLoading }: ChargesProps) {
    const [showNotification, setShowNotification] = useState(false);
    const [notificationText, setNotificationText] = useState('');

    // RETURN ELEMENT
    return (
        <>
            {/* NOTIFICATION */}
            <FeedbackAlert
                show={showNotification}
                timeout={6000}
                message={notificationText}
                onClose={() => setShowNotification(false)}
            />

            {/* BODY */}
            <Box sx={{ height: '100vh', overflowX: 'hidden', overflowY: 'scroll' }}>
                <Navbar />

                {/* MAIN BODY */}
                <Box component="main" sx={{ minHeight: '100vh', px: 5, pb: 2 }}>
                    <ChargesList
                        setChargesCalculator={setChargesCalculator}
                        charges={charges}
                        setShowNotification={setShowNotification}
                        setNotificationText={setNotificationText}
                        isLoading={isLoading}
                    />
                </Box>

                {/* FOOTER */}
                <Footer />
            </Box>
        </>
    )
}
